module.exports = __webpack_public_path__ + "img/ico_biaoqiannvwusheng.dec9713e.png";